import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrderError } from '../../types/api/response/ordererrorsresponse';
import { IOrderErrorsFilters, IOrderErrorsState } from '../../types/store';

const initialState: IOrderErrorsState = {
  errors: [],
  totalElements: 0,
  filters: {
    stage: null,
    dependency: null,
    search: '',
  },
  pagination: { page: 0, size: 20 },
  selectedError: null,
};

const orderErrorsSlice = createSlice({
  name: 'orderErrorsSlice',
  initialState,
  reducers: {
    setOrderErrors: (
      state,
      action: PayloadAction<{ content: IOrderError[]; totalElements: number }>,
    ) => {
      state.errors = action.payload.content;
      state.totalElements = action.payload.totalElements;
    },
    setSelectedError: (state, action: PayloadAction<IOrderError | null>) => {
      state.selectedError = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<IOrderErrorsFilters>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPagination: (state, action: PayloadAction<{ page: number; size: number }>) => {
      state.pagination = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.errors = [];
      state.totalElements = 0;
      state.pagination = initialState.pagination;
      state.selectedError = null;
    },
  },
});

export const { setOrderErrors, setSelectedError, setFilters, setPagination, resetFilters } =
  orderErrorsSlice.actions;

export default orderErrorsSlice.reducer;
